import { Box, Flex, Grid, GridItem, Heading, Tag, Text } from '@chakra-ui/react'
import PropTypes from 'prop-types'

export const UiTableFilters = ({ filterFieldValues = [], filterSelections = {}, updateFilterSelections, placeholderValue = 'No data', ...rest }) => {
  return (
    <Grid
      templateColumns="repeat(5, 1fr)"
      gap={4}
      {...rest}
    >
      {filterFieldValues.map(v => {
        const { field, name, values } = v
        return (
          <GridItem key={field}>
            <Heading size="xs" mb={2}>{name}</Heading>
            <Box
              borderWidth={1}
              borderStyle="solid"
              borderColor="blue.300"
              borderRadius={4}
              padding={3}
              height="150px"
              overflow="auto"
            >
              {values.map(u => { // u : { value: v, count: c }
                const isSelected = filterSelections[field] ? filterSelections[field].includes(u.value) : false
                return (
                  <Flex
                    key={u.value}
                    justifyContent="space-between"
                    gap={4}
                    bg={isSelected ? 'blue.200' : 'white'}
                    cursor="pointer"
                    onClick={() => updateFilterSelections(field, u.value)}
                    px={2}
                    py={1}
                  >
                    <Text fontSize="xs">{u.value || placeholderValue}</Text>
                    <Tag colorScheme="gray" size="sm">{u.count || 0}</Tag>
                  </Flex>
                )
              })}
            </Box>
          </GridItem>
        )
      })}
    </Grid>
  )
}

UiTableFilters.propTypes = {
  filterFieldValues: PropTypes.arrayOf(PropTypes.object),
  filterSelections: PropTypes.object,
  updateFilterSelections: PropTypes.func,
  placeholderValue: PropTypes.string
}
